import { render, staticRenderFns } from "./PurchaseRequisitionsDetail.vue?vue&type=template&id=dea2be9a&lang=pug&"
import script from "./PurchaseRequisitionsDetail.vue?vue&type=script&lang=js&"
export * from "./PurchaseRequisitionsDetail.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseRequisitionsDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports